export enum CartState {
  EMPTY = 'empty',
  LOADING = 'loading',
  LISTING = 'listing',
  GATHERING_USER_INFO = 'gathering_user_info',
  CREATING = 'creating',
  DISPLAYING_LINKS = 'displaying_links',
  ERROR = 'error',
}

export enum EDirection {
  up = "up",
  down = "down",
}

export enum EchallengeImages {
  screenCapture = "screen",
  importance_diversification = "importance_diversification.png",
  sequence_risk = "sequence_risk.png",
  safe_investments = "safe_investments.png",
  investment_risk = "investment_risk.png",
  behind_numbers = "behind_numbers.png",
  longevity = "longevity.png",
  safe_withdrawal = "safe_withdrawal.png",
  income_gap = "income_gap.png",
  tax_triangle = "tax_triangle.png",
  tax_ratio = "tax_ratio.png",
}

export enum EcartType {
  challenge = "challenge",
  indexed = "indexed",
}

export enum ECartSSAWorkflow {
  none = "none",
  rates = "rates",
  historical = "historical",
}
